module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4",
    attrs: {
      "id": "my-profile-view"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix mxn3"
  }, [_c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "bold fz24 mb3"
  }, [_vm._v("Rediger informasjon")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold ft2 uppercase mb1"
  }, [_vm._v("Personlig informasjon")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('name')
    }
  }, [_c('label', [_vm._v("Fullt navn")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  }), _vm._v(" "), (_vm.errors.hasError('name')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('name')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('email')
    }
  }, [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (_vm.errors.hasError('email')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('email')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('phone')
    }
  }, [_c('label', [_vm._v("Mobil")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  }), _vm._v(" "), (_vm.errors.hasError('phone')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('phone')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-wide m0 p1 px3",
    attrs: {
      "disabled": _vm.state.is('saving')
    },
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Lagre profil\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "bold fz24 mb3"
  }, [_vm._v("Endre passord")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold ft2 uppercase mb1"
  }, [_vm._v("Ditt personlige passord")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password')
    }
  }, [_c('label', [_vm._v("Ønsket passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.new),
      callback: function($$v) {
        _vm.$set(_vm.password, "new", $$v)
      },
      expression: "password.new"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password_confirm')
    }
  }, [_c('label', [_vm._v("Gjennta ønsket passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.newConfirm),
      callback: function($$v) {
        _vm.$set(_vm.password, "newConfirm", $$v)
      },
      expression: "password.newConfirm"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password_confirm')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password_confirm')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password_old')
    }
  }, [_c('label', [_vm._v("Gammelt passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.old),
      callback: function($$v) {
        _vm.$set(_vm.password, "old", $$v)
      },
      expression: "password.old"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password_old')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password_old')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-wide m0 p1 px3",
    attrs: {
      "disabled": _vm.state.is('saving-password')
    },
    nativeOn: {
      "click": function($event) {
        _vm.savePassword()
      }
    }
  }, [_vm._v("\n          Endre passord\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4"
  }, [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Min profil")]), _vm._v(" "), _c('p', {
    staticClass: "fz16"
  }, [_vm._v("Her kan du redigere din personelige informasjon og endre passordet ditt.\n    ")]), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041f0354","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/settings/MyProfile.vue
// module id = 633
// module chunks = 1